<his-plam *ngIf="!readonly">
    <p-calendar #content [hisDdKey]="i18nIdentifier" class="inputWidth100" [required]="isMandatory()"
        [(ngModel)]="value" (ngModelChange)="onModelChange($event)">
    </p-calendar>
</his-plam>

<div *ngIf="readonly && value" class="layoutBlock detailPresentationListItem">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{ i18nIdentifier | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{value | hisDate}}</span>
    </div>
</div>
